import React from "react";
import {PaginationLinks} from "./PaginationLinks";
import {PaginationToolbar} from "./PaginationToolbar";
import "./pagination-mobile.css";

export function Pagination(props) {
  const { children, isLoading, paginationProps } = props;
  return (
    <>
      {children}
      <div className="d-flex justify-content-between align-items-center flex-wrap pagination-container-mobile">
        <PaginationLinks paginationProps={paginationProps} />
        <div className="d-none d-md-block">
          <PaginationToolbar
            isLoading={isLoading}
            paginationProps={paginationProps}
          />
        </div>
      </div>
    </>
  );
}
